import React from "react";
import ServicesSection from "./services/services-section";

export default function Services() {
  return <ServicesSection />;
}
